import verificationsForm from '@/pages/requests/VerificationsForm.vue'

export default [
  {
    path: '/verifications/',
    alias: [],
    component: verificationsForm
  },
  {
    path: '/verifications/SIREN/',
    alias: [],
    component: verificationsForm
  },
  {
    path: '/verifications/KBIS/',
    alias: [],
    component: verificationsForm
  },
  {
    path: '/verifications/UBO/',
    alias: [],
    component: verificationsForm
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/verifications.js